import { VehicleImageUrlBuilder } from './VehicleImageUrlBuilder';
import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { IVumFlattenedVehicle } from '../vum/VumFlattenedVehicleConverter';

export interface IVehicleImage {
    readonly url: string;
    readonly viewDirection: string;
    readonly angle: string;
}

export interface IVehicleImagesResponse {
    readonly images: IVehicleImage[];
    readonly service: string;
}

export class VehicleImageClient {

    constructor(
        private readonly vehicleImageUrlBuilder: VehicleImageUrlBuilder,
        private readonly authService: IAuthServiceV2,
        private readonly stage: string,
    ) {
    }

    public async getImages(vehicle: IVumFlattenedVehicle): Promise<IVehicleImagesResponse> {
        const imageServiceUrl = this.vehicleImageUrlBuilder.getUrlForImageRequestWithDefaultView(vehicle);

        const response = await this.authService.get(`myvw-vilma-proxy-${this.stage}`, imageServiceUrl);
        if (response.ok) {
            return await response.json() as IVehicleImagesResponse;
        }

        throw new Error(await response.text());
    }
}
